import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, {
    staticClass: "send-downlink"
  }, [_c(VCol, {
    attrs: {
      "cols": "4",
      "md": "2",
      "align": "left",
      "justify": "end"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.payload'),
      "outlined": "",
      "color": _vm.color,
      "hide-details": "auto"
    },
    on: {
      "input": value => {
        _vm.onValueChange(value, 'payload');
      }
    },
    model: {
      value: _vm.payload,
      callback: function ($$v) {
        _vm.payload = $$v;
      },
      expression: "payload"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "1",
      "md": "1",
      "align": "left"
    }
  }, [_vm.fcnt ? _c('custom-fields-displayField', {
    attrs: {
      "type": "icon",
      "label": "FCNT",
      "value": _vm.fcnt,
      "icon": 'check',
      "iconColor": _vm.color
    }
  }) : _vm._e()], 1), _c(VCol, {
    attrs: {
      "cols": "1",
      "md": "1",
      "align": "center",
      "justify": "end"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.loRaPort'),
      "outlined": "",
      "color": _vm.color,
      "hide-details": "auto"
    },
    on: {
      "input": value => {
        _vm.onValueChange(value, 'port');
      }
    },
    model: {
      value: _vm.port,
      callback: function ($$v) {
        _vm.port = $$v;
      },
      expression: "port"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "1",
      "md": "1",
      "align": "left"
    }
  }, [_vm.fcnt ? _c('custom-fields-displayField', {
    attrs: {
      "type": "icon",
      "label": "FCNT",
      "value": _vm.fcnt,
      "icon": 'check',
      "iconColor": _vm.color
    }
  }) : _vm._e()], 1), _c(VCol, {
    attrs: {
      "cols": "2",
      "md": "2",
      "align": "center",
      "justify": "center"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.confirmed')
    },
    on: {
      "change": function ($event) {
        _vm.confirmed = !_vm.confirmed;
      }
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "2",
      "md": "2",
      "align": "right",
      "justify": "center"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.flushQueue')
    },
    on: {
      "change": function ($event) {
        _vm.flushQueue = !_vm.flushQueue;
      }
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "1",
      "md": "1",
      "align": "left"
    }
  }, [_vm.fcnt ? _c('custom-fields-displayField', {
    attrs: {
      "type": "icon",
      "label": "FCNT",
      "value": _vm.fcnt,
      "icon": 'check',
      "iconColor": _vm.color
    }
  }) : _vm._e()], 1), _c(VCol, {
    attrs: {
      "cols": "2",
      "md": "2",
      "align": "right",
      "justify": "center"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-bow-arrow",
      "disabled": !_vm.isReadyForSend(),
      "loading": _vm.sendingDownlink
    },
    on: {
      "click": function ($event) {
        return _vm.sendDownlink();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.details.send')) + "\n      ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };